<div id="tooltip" style="position: absolute;" >
    <div id="tooltiptriangle">
      <span (click)="rootMemberChangeBtnClicked()" style="cursor: pointer;  "> <img style="width: 15px"
          [src]="changeRMUrl" /> {{"lbl_changeRootMember" | translate}} </span><br>
      <span (click)="openIndividualEditorBtnClicked()" style="cursor: pointer; " > <img style="width: 15px" [src]="editUrl" /> {{"lbl_edit" | translate}} </span>
  
    </div>
    <div id="arrow-down"></div>
</div>